<script setup lang="ts">
import DeviceTableCardMode from '@/components/DeviceComponents/Table/DeviceTableCardMode.vue'
import { DEVICE_ROUTES } from '@/router/routes'
import organizationApi from '@/services/organization.service'
import SocketDeviceAlertsWrapper from '@/socket/SocketDeviceAlertsWrapper.vue'
import { type DeviceModel } from '@/types/models/DeviceModel'
import { EOrganizationsDevicesPerm } from '@/types/permissions/OrganizationsPermissionsEnum'
import type { AlertSocketMessageModel } from '@/types/socket/SocketAlertModel'
import type { SocketDeviceDetectionModel } from '@/types/socket/SocketDetectionModel'
import { onMounted, provide, ref, watch } from 'vue'

provide('hideDetectionsData', true)

type Props = {
    detections?: SocketDeviceDetectionModel[]
    siteId: number
    currentEvent?: boolean
    associates?: number[]
}
const props = defineProps<Props>()
type Emits = {
    (e: 'devicesUpdate', value: SocketDeviceDetectionModel[]): void
}
defineEmits<Emits>()

const latestDetections = ref<SocketDeviceDetectionModel[]>([])
watch(
    () => props.detections,
    newDetection => (newDetection?.length ? (latestDetections.value = newDetection) : undefined)
)
watch(
    () => props.associates,
    () => getDevices()
)

const devices = ref<DeviceModel[]>([])
const getDevices = () =>
    organizationApi.getMyDevices({ per_page: -1, filters: { site_id: props.siteId } }).then(res => {
        devices.value = res.data as DeviceModel[]
    })

onMounted(() => getDevices())

const deviceAlerts = ref<AlertSocketMessageModel[]>([])
const handleAlertsUpdate = (value: AlertSocketMessageModel[]) => (deviceAlerts.value = value)
</script>

<template>
    <SocketDeviceAlertsWrapper
        v-if="currentEvent"
        :device_ids="devices.map(item => item.device_id ?? item.id)"
        @update="handleAlertsUpdate" />

    <DeviceTableCardMode
        :data="devices"
        :statuses="deviceAlerts"
        :detections="detections"
        showNextCheckpoint
        :editPermission="EOrganizationsDevicesPerm.ORGANIZATIONS_DEVICES_VIEW"
        :editButtonHref="DEVICE_ROUTES.baseUrl" />
</template>
